import { has } from 'lodash';

export default {
  namespaced: true,
  state: {
    active: false,
    data: {
      target: '',
      action: '',
      obj: {},
    },
  },
  getters: {
    active: state => state.active,
    data: state => state.data,
  },
  mutations: {
    mutateActive(state, data) {
      state.active = data;
    },
    mutateData(state, data) {
      // eslint-disable-next-line
      for(let key in data){
        if (_.has(state.data, key)) {
          state.data[key] = data[key];
        }
      }
      // state.data = data;
    },
  },
  actions: {
    setActive(context, data) {
      context.commit('mutateActive', data);
    },
    setData(context, data) {
      context.commit('mutateData', data);
    },
  },
};
